import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build, cannot } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user) {
        can('read', 'Obra')
        can('seeAll', 'Obra')

        if (user.temPermissao(['admin_obra'])) {
            can('manage', 'Obra')
        }
        if (user.temPermissao(['obra'])) {
            can(['create', 'update', 'delete', 'inspect'], 'Obra')
        }

    }

    return build()
}